import type { CSSProperties, ReactNode } from "react";

export type PillTone =
  | "ok"
  | "warn"
  | "risk"
  | "info"
  | "accent"
  | "ghost"
  | "solid-ok"
  | "solid-risk"
  | "default";

export function Pill({
  tone = "default",
  dot,
  children,
  style,
  className,
}: {
  tone?: PillTone;
  dot?: boolean;
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}) {
  const cls = [
    "pill",
    tone === "default" ? "" : tone,
    dot ? "dot" : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <span className={cls} style={style}>
      {children}
    </span>
  );
}
